import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu, Button, Space, Spin, Drawer, Modal, List, Typography } from 'antd';
import {
  HomeOutlined,
  EnvironmentOutlined,
  DashboardOutlined,
  SettingOutlined,
  AuditOutlined,
  MailOutlined,
  TeamOutlined,
  BarChartOutlined,
  UserOutlined,
  LogoutOutlined,
  AppstoreOutlined,
  MenuOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MinusSquareOutlined,
  PlusSquareOutlined,
  SortAscendingOutlined,
  ContactsOutlined,
  SendOutlined,
  GlobalOutlined,
  RobotOutlined,
  FunnelPlotOutlined,
  FundProjectionScreenOutlined,
  GoogleOutlined,
  FacebookOutlined,
  MessageOutlined,
  VideoCameraOutlined,
  ShopOutlined,
  DollarOutlined,
  ReadOutlined,
  CalendarOutlined,
  SearchOutlined,
  RadarChartOutlined,
  ScheduleOutlined,
  TrophyOutlined,
  CrownOutlined,
  CloudServerOutlined,
  LinkOutlined,
  ThunderboltOutlined,
  LoginOutlined,
  BugOutlined,
  CodeOutlined,
  ToolOutlined,
  ProjectOutlined,
  DatabaseOutlined,
  ApartmentOutlined,
  RocketOutlined,
  FileExcelOutlined,
  GiftOutlined,
  AudioOutlined,
  FileTextOutlined,
  ApiOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import HomePage from './pages/HomePage';
import LOIDashboardPage from './pages/LOIDashboardPage';
import LOIManagePage from './pages/LOIManagePage';
import LOISurveyPage from './pages/LOISurveyPage';
import TenderConfirmPage from './pages/TenderConfirmPage';
import TenderDashboardPage from './pages/TenderDashboardPage';
import PriceCatalogPage from './pages/PriceCatalogPage';
import FullSurveyPage from './pages/FullSurveyPage';
import EmailComposePage from './pages/EmailComposePage';
import SeminarAdminPage from './pages/SeminarAdminPage';
import AnalyticsPage from './pages/AnalyticsPage';
import MonitoringPage from './pages/MonitoringPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import UserManagementPage from './pages/UserManagementPage';
import LoginAnalyticsPage from './pages/LoginAnalyticsPage';
import DevRequestsPage from './pages/DevRequestsPage';
import TerminalPage from './pages/TerminalPage';
import BackupManagementPage from './pages/BackupManagementPage';
import ScenarioListPage from './pages/ScenarioListPage';
import ScenarioBuilderPage from './pages/ScenarioBuilderPage';
import ContactsPage from './pages/ContactsPage';
import EmailCampaignPage from './pages/EmailCampaignPage';
import LandingPageAdminPage from './pages/LandingPageAdminPage';
import ChatbotAdminPage from './pages/ChatbotAdminPage';
import FunnelDashboardPage from './pages/FunnelDashboardPage';
import AIModelConfigPage from './pages/AIModelConfigPage';
import MarketingToolsPage from './pages/MarketingToolsPage';
import GoogleAdsHubPage from './pages/GoogleAdsHubPage';
import FacebookHubPage from './pages/FacebookHubPage';
import FbAdCreatorPage from './pages/FbAdCreatorPage';
import ApiKeyPage from './pages/ApiKeyPage';
import MiraChatPage from './pages/MiraChatPage';
import Wav2LipPage from './pages/Wav2LipPage';
import VideoTranscribePage from './pages/VideoTranscribePage';
import MarketingSiteListPage from './pages/MarketingSiteListPage';
import MarketingSiteDashboardPage from './pages/MarketingSiteDashboardPage';
import AeoScannerPage from './pages/AeoScannerPage';
import AeoFixPage from './pages/AeoFixPage';
import CitationMonitorPage from './pages/CitationMonitorPage';
import BusinessModuleMapPage from './pages/BusinessModuleMapPage';
import ScenarioSiteLayout from './pages/ScenarioSite/ScenarioSiteLayout';
import ScenarioSiteAdminPage from './pages/ScenarioSiteAdminPage';
import CustomerHomePage from './pages/CustomerHomePage';
import CustomerEmailPage from './pages/CustomerEmailPage';
import BillingPage from './pages/BillingPage';
import AeoLandingPage from './pages/AeoLandingPage';
import CouponRequestPage from './pages/CouponRequestPage';
import AdminCouponPage from './pages/AdminCouponPage';
import CustomerListPage from './pages/CustomerListPage';
import QuotationPage from './pages/QuotationPage';
import PresentationPage from './pages/PresentationPage';
import CustomerBackendPage from './pages/CustomerBackendPage';
import ProductListPage from './pages/ProductListPage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import EventManagePage from './pages/EventManagePage';
import LineSettingsPage from './pages/LineSettingsPage';
import EmailMarketingPage from './pages/EmailMarketing/EmailMarketingPage';
import MarketingSchedulerPage from './pages/MarketingSchedulerPage';
import AISalesCompetitionPage from './pages/AISalesCompetitionPage';
import BotDetailPage from './pages/BotDetailPage';
import BotChatPage from './pages/BotChatPage';
import BotProposalsPage from './pages/BotProposalsPage';
import TrendsSearchPage from './pages/TrendsSearchPage';
import TrendsReportsPage from './pages/TrendsReportsPage';
import TrendsSettingsPage from './pages/TrendsSettingsPage';
import AlayaessBindingsPage from './pages/AlayaessBindingsPage';
import AlayaessBotsPage from './pages/AlayaessBotsPage';
import PartnerPortalPage from './pages/PartnerPortalPage';
import PartnerManagePage from './pages/PartnerManagePage';
import PartnershipPage from './pages/PartnershipPage';
import PartnershipManagePage from './pages/PartnershipManagePage';
import HousePortalLayout from './pages/HousePortal/HousePortalLayout';
import HouseDashboardPage from './pages/HouseAI/HouseDashboardPage';
import MarComLandingPage from './pages/MarComLandingPage';
import DevSpecPage from './pages/DevSpecPage';
import DevSpecViewPage from './pages/DevSpecViewPage';
import DevSurveyPage from './pages/DevSurveyPage';
import CDPPage from './pages/CDPPage';
import SalesFlowPage from './pages/SalesFlowPage';
import UlinkSalesPage from './pages/UlinkSalesPage';
import UlinkLineInboxPage from './pages/UlinkLineInboxPage';
import HouseAIRentalPage from './pages/HouseAIRentalPage';
import OfficeSearchPage from './pages/OfficeSearchPage';
import HomeSearchPage from './pages/HomeSearchPage';
import HotelSearchPage from './pages/HotelSearchPage';
import JJDashboardPage from './pages/JJDashboardPage';
import JJInboxPage from './pages/JJInboxPage';
import JJCRMPage from './pages/JJCRMPage';
import JJKeywordsPage from './pages/JJKeywordsPage';
import JJPropertyManagementPage from './pages/JJPropertyManagementPage';
import JJRenewalsPage from './pages/JJRenewalsPage';
import OpenHouseKioskPage from './pages/OpenHouse/OpenHouseKioskPage';
import OpenHouseAdminPage from './pages/OpenHouse/OpenHouseAdminPage';
import { authAPI } from './services/api';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './components/LanguageSwitcher';
import './App.css';

const { Header, Content, Footer, Sider } = Layout;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

function getMenuItems(currentUser, t) {
  const isCustomer = currentUser && currentUser.role === 'customer';
  const isAdmin = currentUser && currentUser.role === 'admin';

  // Customer with NO custom menu_config: show limited default set
  if (isCustomer && !currentUser?.menu_config) {
    return [
      { key: '/', icon: <HomeOutlined />, label: <Link to="/">{t('sidebar.home')}</Link> },
      { key: '/scenarios', icon: <AppstoreOutlined />, label: <Link to="/scenarios">{t('sidebar.scenarios')}</Link> },
      { key: '/marketing-sites', icon: <GlobalOutlined />, label: <Link to="/marketing-sites">{t('sidebar.marketingSites')}</Link> },
      { key: '/products', icon: <ShopOutlined />, label: <Link to="/products">{t('sidebar.products')}</Link> },
      { key: '/blog', icon: <ReadOutlined />, label: <Link to="/blog">{t('sidebar.blog')}</Link> },
      { key: '/events', icon: <CalendarOutlined />, label: <Link to="/events">{t('sidebar.events')}</Link> },
      { key: '/contacts', icon: <ContactsOutlined />, label: <Link to="/contacts">{t('sidebar.contacts')}</Link> },
      { key: '/email-compose', icon: <MailOutlined />, label: <Link to="/email-compose">{t('sidebar.email')}</Link> },
      { key: '/billing', icon: <DollarOutlined />, label: <Link to="/billing">{t('sidebar.billing')}</Link> },
            { key: '/admin-coupon', icon: <GiftOutlined />, label: <Link to="/admin-coupon">{t('sidebar.adminCoupon', '優惠券管理')}</Link> },
            { key: '/chatbot', icon: <RobotOutlined />, label: <Link to="/chatbot">{t('sidebar.chatbot')}</Link> },
      { key: '/funnel', icon: <FunnelPlotOutlined />, label: <Link to="/funnel">{t('sidebar.funnel')}</Link> },
      { key: '/landing-pages', icon: <GlobalOutlined />, label: <Link to="/landing-pages">{t('sidebar.landingPages')}</Link> },
      { key: '/mira', icon: <MessageOutlined />, label: <Link to="/mira">Mira AI</Link> },
      { key: '/line', icon: <SendOutlined />, label: <Link to="/line">LINE Bot</Link> },
    ];
  }

  // Admin / Manager (or customer with custom menu_config) see all items
  const items = [
    { key: '/', icon: <HomeOutlined />, label: <Link to="/">{t('sidebar.home', '首頁')}</Link> },

    // Open House（美國 agent：Godfrey）
    {
      key: 'open-house-group',
      icon: <HomeOutlined style={{ color: '#fa8c16' }} />,
      label: 'Open House',
      children: [
        { key: '/oh/la-terrace', icon: <PhoneOutlined />, label: <Link to="/oh/la-terrace">Open House Kiosk</Link> },
        { key: '/oh/la-terrace/admin', icon: <TeamOutlined />, label: <Link to="/oh/la-terrace/admin?key=rlelZa0Clu_RYaYR">Buyer Leads</Link> },
      ],
    },

    // JJ Bangkok Real Estate
    {
      key: 'jj-group',
      icon: <span>🏙️</span>,
      label: t('sidebar.jjGroup', 'Bangkok'),
      children: [
        { key: '/jj-dashboard', icon: <span>📊</span>, label: <Link to="/jj-dashboard">{t('sidebar.jjDashboard', 'Dashboard')}</Link> },
        { key: '/jj-inbox', icon: <span>📨</span>, label: <Link to="/jj-inbox">{t('sidebar.jjInbox', 'Inbox')}</Link> },
        { key: '/jj-crm', icon: <span>📋</span>, label: <Link to="/jj-crm">{t('sidebar.jjCRM', 'Case Management CRM')}</Link> },
        { key: '/jj-properties', icon: <HomeOutlined style={{ color: '#13c2c2' }} />, label: <Link to="/jj-properties">{t('sidebar.jjProperties', '房屋管理')}</Link> },
        { key: '/jj-keywords', icon: <span>🔑</span>, label: <Link to="/jj-keywords">{t('sidebar.jjKeywords', 'Property Keywords')}</Link> },
        { key: '/jj-renewals', icon: <span>🔄</span>, label: <Link to="/jj-renewals">{t('sidebar.jjRenewals', 'Renewals')}</Link> },
                { key: '/house-ai', icon: <HomeOutlined style={{ color: '#e8363a' }} />, label: <Link to="/house-ai">HOUSE AI</Link> },
        { key: '/house-ai-rental', icon: <HomeOutlined style={{ color: '#fa8c16' }} />, label: <Link to="/house-ai-rental">{t('sidebar.houseRental', 'Property Search')}</Link> },
        { key: '/office-search', icon: <EnvironmentOutlined style={{ color: '#13c2c2' }} />, label: <Link to="/office-search">{t('sidebar.officeSearch', 'Office Rental')}</Link> },
        { key: '/home-search', icon: <HomeOutlined style={{ color: '#fa8c16' }} />, label: <Link to="/home-search">{t('sidebar.homeSearch', 'Home Rental')}</Link> },
        { key: '/jj-hotels', icon: <span>🏨</span>, label: <Link to="/jj-hotels">{t('sidebar.jjHotels', 'Hotel Search')}</Link> },
      ],
    },

    // Marketing
    {
      key: 'marketing-group',
      icon: <AppstoreOutlined />,
      label: t('sidebar.marketing', '行銷'),
      children: [
        { key: '/scenarios', icon: <AppstoreOutlined />, label: <Link to="/scenarios">{t('sidebar.scenarios', '行銷情境')}</Link> },
        { key: '/marketing-sites', icon: <GlobalOutlined />, label: <Link to="/marketing-sites">{t('sidebar.marketingSites', '行銷網站')}</Link> },
        { key: '/blog', icon: <ReadOutlined />, label: <Link to="/blog">{t('sidebar.blog', '部落格管理')}</Link> },
        { key: '/landing-pages', icon: <GlobalOutlined />, label: <Link to="/landing-pages">{t('sidebar.landingPages', 'Landing Pages')}</Link> },
        { key: '/marketing-scheduler', icon: <ScheduleOutlined />, label: <Link to="/marketing-scheduler">{t('sidebar.marketingScheduler', '行銷排程')}</Link> },
        { key: '/video-transcribe', icon: <AudioOutlined />, label: <Link to="/video-transcribe">{t('sidebar.videoTranscribe', '影片分析素材')}</Link> },
        { key: '/wav2lip', icon: <VideoCameraOutlined />, label: <Link to="/wav2lip">{t('sidebar.wav2lip', 'AI Video')}</Link> },
        { key: '/module-map', icon: <AppstoreOutlined />, label: <Link to="/module-map">{t('sidebar.moduleMap', 'Module Map')}</Link> },
      ],
    },

    // Advertising
    {
      key: 'ads-group',
      icon: <FacebookOutlined />,
      label: t('sidebar.ads', '廣告投放'),
      children: [
        { key: '/facebook', icon: <FacebookOutlined />, label: <Link to="/facebook">{t('sidebar.facebook', 'Facebook Hub')}</Link> },
        { key: '/fb-ad-creator', icon: <FacebookOutlined />, label: <Link to="/fb-ad-creator">{t('sidebar.fbAdCreator', 'FB Ad Creator')}</Link> },
        { key: '/google-ads', icon: <GoogleOutlined />, label: <Link to="/google-ads">Google Ads</Link> },
        { key: '/marketing-tools', icon: <FundProjectionScreenOutlined />, label: <Link to="/marketing-tools">{t('sidebar.marketingTools', '行銷工具設定')}</Link> },
      ],
    },

    // Customer Engagement
    {
      key: 'crm-group',
      icon: <ContactsOutlined />,
      label: t('sidebar.crm', '客戶互動'),
      children: [
        { key: '/contacts', icon: <ContactsOutlined />, label: <Link to="/contacts">{t('sidebar.contacts', '聯絡人管理')}</Link> },
        { key: '/email-campaigns', icon: <SendOutlined />, label: <Link to="/email-campaigns">{t('sidebar.emailCampaigns', '郵件行銷')}</Link> },
        { key: '/email-marketing', icon: <MailOutlined />, label: <Link to="/email-marketing">EMBot</Link> },
        { key: '/line', icon: <SendOutlined />, label: <Link to="/line">LINE Bot</Link> },
        { key: '/chatbot', icon: <RobotOutlined />, label: <Link to="/chatbot">AI Chatbot</Link> },
        { key: '/mira', icon: <MessageOutlined />, label: <Link to="/mira">Mira AI</Link> },
        { key: '/funnel', icon: <FunnelPlotOutlined />, label: <Link to="/funnel">{t('sidebar.funnel', '行銷漏斗')}</Link> },
      ],
    },

    // AI Tools
    {
      key: 'ai-tools-group',
      icon: <RobotOutlined />,
      label: t('sidebar.aiTools', 'AI 工具'),
      children: [
        { key: '/quotation', icon: <FileExcelOutlined />, label: <Link to="/quotation">{t('sidebar.quotation', 'AI Quotation')}</Link> },
        { key: '/presentation', icon: <FileTextOutlined />, label: <Link to="/presentation">{t('sidebar.presentation', 'AI Presentation')}</Link> },
        {
          key: 'ai-sales-group',
          icon: <TrophyOutlined />,
          label: t('sidebar.aiSales', 'AI Sales'),
          children: [
            { key: '/ai-sales', icon: <TrophyOutlined />, label: <Link to="/ai-sales">{t('sidebar.aiSalesComp', 'Sales Competition')}</Link> },
            { key: '/ai-sales/proposals', icon: <ThunderboltOutlined />, label: <Link to="/ai-sales/proposals">{t('sidebar.aiProposals', 'Bot Proposals')}</Link> },
            { key: '/alayaess-bots', icon: <RobotOutlined />, label: <Link to="/alayaess-bots">AlayaEss Bots</Link> },
            { key: '/alayaess-bindings', icon: <LinkOutlined />, label: <Link to="/alayaess-bindings">AlayaEss Bindings</Link> },
          ],
        },
        {
          key: 'ai-seo-group',
          icon: <RadarChartOutlined />,
          label: <Link to="/aeo">AI SEO</Link>,
          children: [
            { key: '/aeo', icon: <RadarChartOutlined />, label: <Link to="/aeo">{t('sidebar.aeoOverview', '功能總覽')}</Link> },
            { key: '/aeo-scanner', icon: <SearchOutlined />, label: <Link to="/aeo-scanner">AEO Scanner</Link> },
            { key: '/aeo-fix', icon: <ToolOutlined />, label: <Link to="/aeo-fix">{t('sidebar.aeoFix', 'AI Auto-Fix')}</Link> },
            { key: '/citation-monitor', icon: <BarChartOutlined />, label: <Link to="/citation-monitor">{t('sidebar.citationMonitor', 'AI Citation Monitor')}</Link> },
            { key: '/coupon-request', icon: <GiftOutlined />, label: <Link to="/coupon-request">{t('sidebar.couponRequest', '申請優惠券')}</Link> },
          ],
        },
        {
          key: 'ai-research-group',
          icon: <SearchOutlined />,
          label: t('sidebar.aiResearch', 'AI Research'),
          children: [
            { key: '/research/trends', icon: <ThunderboltOutlined />, label: <Link to="/research/trends">{t('sidebar.trends', 'Trends')}</Link> },
            { key: '/research/reports', icon: <ReadOutlined />, label: <Link to="/research/reports">{t('sidebar.reports', 'Reports')}</Link> },
            { key: '/research/settings', icon: <SettingOutlined />, label: <Link to="/research/settings">{t('sidebar.sourceSettings', 'Source Settings')}</Link> },
          ],
        },
      ],
    },

    // Business
    {
      key: 'biz-group',
      icon: <ShopOutlined />,
      label: t('sidebar.bizManagement', '業務管理'),
      children: [
        { key: '/products', icon: <ShopOutlined />, label: <Link to="/products">{t('sidebar.products', '產品管理')}</Link> },
        { key: '/loi', icon: <DashboardOutlined />, label: <Link to="/loi">{t('sidebar.loi', '意向書管理')}</Link> },
        { key: '/loi/manage', icon: <SettingOutlined />, label: <Link to="/loi/manage">{t('sidebar.loiImport', 'LOI Import')}</Link> },
        { key: '/tender', icon: <AuditOutlined />, label: <Link to="/tender">{t('sidebar.tender', '招標管理')}</Link> },
        { key: '/billing', icon: <DollarOutlined />, label: <Link to="/billing">{t('sidebar.billing', '帳務中心')}</Link> },
        ],
    },

    // Events
    {
      key: 'events-group',
      icon: <CalendarOutlined />,
      label: t('sidebar.eventsGroup', '活動 & 事件'),
      children: [
        { key: '/events', icon: <CalendarOutlined />, label: <Link to="/events">{t('sidebar.events', '活動報名管理')}</Link> },
        { key: '/seminar', icon: <TeamOutlined />, label: <Link to="/seminar">{t('sidebar.seminar', '論壇報名')}</Link> },
        { key: '/email-compose', icon: <MailOutlined />, label: <Link to="/email-compose">{t('sidebar.email', '信件發送')}</Link> },
      ],
    },

    // Partners
    {
      key: 'partner-group',
      icon: <TeamOutlined />,
      label: t('sidebar.partners', '合作夥伴'),
      children: [
        { key: '/partner-manage', icon: <TeamOutlined />, label: <Link to="/partner-manage">Partner Portal</Link> },
        { key: '/partnership-manage', icon: <CrownOutlined />, label: <Link to="/partnership-manage">Partnership</Link> },
      ],
    },

    // Analytics
    {
      key: 'analytics-group',
      icon: <BarChartOutlined />,
      label: t('sidebar.analytics', '分析報告'),
      children: [
        { key: '/analytics', icon: <BarChartOutlined />, label: <Link to="/analytics">{t('sidebar.visitorAnalytics', '訪客分析')}</Link> },
        { key: '/monitoring', icon: <DashboardOutlined />, label: <Link to="/monitoring">{t('sidebar.monitoring', '監控中心')}</Link> },
      ],
    },

    // CDP — Customer Data Platform
    {
      key: 'cdp-group',
      icon: <RocketOutlined />,
      label: t('sidebar.ulinkSalesGroup', 'ulink-銷售'),
      children: [
        { key: '/ulink-sales', icon: <RocketOutlined />, label: <Link to="/ulink-sales">{t('sidebar.ulinkSales', '引流 + LINE 推播')}</Link> },
        { key: '/ulink-line-inbox', icon: <MessageOutlined />, label: <Link to="/ulink-line-inbox">{t('sidebar.ulinkLineInbox', 'Mira LINE 收件匣')}</Link> },
        { key: '/cdp', icon: <DatabaseOutlined />, label: <Link to="/cdp">{t('sidebar.cdp', 'CDP 客戶中台')}</Link> },
        { key: '/sales-flow', icon: <ApartmentOutlined />, label: <Link to="/sales-flow">{t('sidebar.salesFlow', '銷售流程圖')}</Link> },
      ],
    },
  ];

  const cleanItems = items;

  if (isAdmin) {
    const analyticsGroup = cleanItems.find(i => i.key === 'analytics-group');
    if (analyticsGroup) {
      analyticsGroup.children.push(
        { key: '/customers', icon: <TeamOutlined />, label: <Link to="/customers">{t('sidebar.customers', '客戶管理')}</Link> },
        { key: '/login-analytics', icon: <LoginOutlined />, label: <Link to="/login-analytics">{t('sidebar.loginAnalytics', '登入分析')}</Link> }
      );
    }

    cleanItems.push({
      key: 'system-group',
      icon: <SettingOutlined />,
      label: t('sidebar.system', '系統管理'),
      children: [
        { key: '/ai-config', icon: <SettingOutlined />, label: <Link to="/ai-config">{t('sidebar.aiConfig', 'AI Model Config')}</Link> },
        { key: '/users', icon: <UserOutlined />, label: <Link to="/users">{t('sidebar.users', '帳號管理')}</Link> },
        { key: '/api-keys', icon: <ApiOutlined />, label: <Link to="/api-keys">{t('sidebar.apiKeys', 'Public API Keys')}</Link> },
        { key: '/dev-spec', icon: <FileTextOutlined />, label: <Link to="/dev-spec">{t('sidebar.devSpec', 'Dev Spec Generator')}</Link> },
        { key: '/dev-requests', icon: <BugOutlined />, label: <Link to="/dev-requests">{t('sidebar.devRequests', 'Dev Requests')}</Link> },
        { key: '/dev-survey', icon: <ProjectOutlined />, label: <Link to="/dev-survey">{t('sidebar.devSurvey', '開發調查表')}</Link> },
        { key: '/terminal', icon: <CodeOutlined />, label: <Link to="/terminal">{t('sidebar.terminal', 'Terminal')}</Link> },
        { key: '/backups', icon: <CloudServerOutlined />, label: <Link to="/backups">{t('sidebar.backups', 'Backups')}</Link> },
        { key: '/module-map', icon: <AppstoreOutlined />, label: <Link to="/module-map">{t('sidebar.moduleMap', 'Module Map')}</Link> },
      ],
    });

  }

  // Apply per-user menu_config filter (admin bypasses)
  if (!isAdmin && currentUser?.menu_config) {
    const cfg = currentUser.menu_config;
    const filterItems = (items) => items
      .filter(item => {
        if (!item.key.startsWith('/')) return true; // group items: keep, filter children
        return cfg[item.key] === true;
      })
      .map(item => {
        if (!item.children) return item;
        const filtered = filterItems(item.children);
        if (filtered.length === 0) return null;
        return { ...item, children: filtered };
      })
      .filter(Boolean);
    return filterItems(cleanItems);
  }

  return cleanItems;
}

// ── Menu order helpers ────────────────────────────────────────────────────────
const MENU_ORDER_KEY = 'spo_menu_group_order';

function applyMenuOrder(items) {
  const saved = (() => {
    try { return JSON.parse(localStorage.getItem(MENU_ORDER_KEY) || 'null'); } catch { return null; }
  })();
  if (!saved || !Array.isArray(saved)) return items;
  const grouped = items.filter(i => i.children);
  const singles = items.filter(i => !i.children);
  const ordered = [
    ...saved.map(key => grouped.find(g => g.key === key)).filter(Boolean),
    ...grouped.filter(g => !saved.includes(g.key)),
  ];
  return [...singles.filter(i => i.key === '/'), ...ordered,
          ...singles.filter(i => i.key !== '/')];
}

function saveMenuOrder(groupKeys) {
  localStorage.setItem(MENU_ORDER_KEY, JSON.stringify(groupKeys));
}

function AppLayout({ currentUser, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [reorderOpen, setReorderOpen] = useState(false);
  const [subscriptionModal, setSubscriptionModal] = useState({ visible: false, message: '' });
  const { t } = useTranslation();

  const rawMenuItems = getMenuItems(currentUser, t);
  const menuItems = applyMenuOrder(rawMenuItems);

  // All group keys visible to this user
  const allGroupKeys = menuItems.filter(i => i.children).map(i => i.key);

  // Controlled open state — start fully expanded
  const [openKeys, setOpenKeys] = useState(allGroupKeys);

  // Listen for subscription required events from API
  useEffect(() => {
    const handler = (e) => {
      setSubscriptionModal({
        visible: true,
        message: e.detail?.message || 'AI SEO 功能需要有效訂閱。',
      });
    };
    window.addEventListener('spo:subscription_required', handler);
    return () => window.removeEventListener('spo:subscription_required', handler);
  }, []);

  // Re-expand all groups whenever the logged-in user changes (login / permission update)
  useEffect(() => {
    const keys = getMenuItems(currentUser, t).filter(i => i.children).map(i => i.key);
    setOpenKeys(keys);
  }, [currentUser?.id, currentUser?.menu_config]); // eslint-disable-line react-hooks/exhaustive-deps

  // When navigating to a page, ensure its parent group is open
  useEffect(() => {
    const findParents = (nodes, path) => {
      const result = [];
      const walk = (ns) => {
        for (const n of (ns || [])) {
          if (!n.children) continue;
          if (n.children.some(c => c.key === path || (c.children || []).some(gc => gc.key === path)))
            result.push(n.key);
          walk(n.children);
        }
      };
      walk(nodes);
      return result;
    };
    const parents = findParents(menuItems, location.pathname);
    if (parents.length > 0) {
      setOpenKeys(prev => [...new Set([...prev, ...parents])]);
    }
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogout = () => {
    localStorage.removeItem('spo_auth_token');
    onLogout();
    navigate('/');
  };

  // Close drawer on route change (mobile)
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  const siderMenu = (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[location.pathname]}
      openKeys={openKeys}
      onOpenChange={setOpenKeys}
      items={menuItems}
      style={{ borderRight: 0 }}
    />
  );

  const siderBottom = (
    <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
      <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginBottom: 8, textAlign: 'center' }}>
        {!collapsed && (currentUser?.display_name || currentUser?.username)}
      </div>
      {!collapsed && (
        <div style={{ marginBottom: 8, textAlign: 'center' }}>
          <LanguageSwitcher ghost style={{ color: 'rgba(255,255,255,0.75)', borderColor: 'rgba(255,255,255,0.25)' }} />
        </div>
      )}
      <Button
        type="text"
        icon={<LogoutOutlined />}
        onClick={handleLogout}
        block
        style={{ color: 'rgba(255,255,255,0.65)' }}
      >
        {!collapsed && t('login.logout')}
      </Button>
    </div>
  );

  return (
    <>
    <Layout style={{ minHeight: '100vh' }}>
      {/* Desktop: collapsible Sider */}
      {!isMobile && (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          trigger={null}
          width={200}
          style={{
            background: 'linear-gradient(180deg, #001529 0%, #003a8c 100%)',
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {/* Logo + controls row */}
            <div style={{
              borderBottom: '1px solid rgba(255,255,255,0.1)',
              display: 'flex', alignItems: 'center',
              justifyContent: collapsed ? 'center' : 'space-between',
              padding: collapsed ? '8px 4px' : '8px 4px 8px 12px',
              minHeight: 56,
              gap: 2,
            }}>
              {/* Logo */}
              <Link to="/" style={{ textDecoration: 'none', flex: collapsed ? 0 : 1, minWidth: 0 }}>
                <img
                  src={collapsed ? '/marcom-ai/marcom-ai-favicon.svg' : '/marcom-ai/marcom-ai-horizontal-onDark.svg'}
                  alt="marcom AI"
                  style={{ height: collapsed ? 36 : 40, width: collapsed ? 36 : 'auto', maxWidth: '100%', display: 'block' }}
                />
              </Link>

              {/* Control buttons — only shown when sidebar is expanded */}
              {!collapsed && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 0, flexShrink: 0 }}>
                  {/* Collapse all submenus */}
                  <Button type="text" icon={<MinusSquareOutlined />}
                    onClick={() => setOpenKeys([])}
                    style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, width: 30, height: 36 }}
                    title={t('sidebar.collapseAll', '收起所有子選單')} />
                  {/* Expand all submenus */}
                  <Button type="text" icon={<PlusSquareOutlined />}
                    onClick={() => setOpenKeys(allGroupKeys)}
                    style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, width: 30, height: 36 }}
                    title={t('sidebar.expandAll', '展開所有子選單')} />
                  {/* Reorder menu */}
                  <Button type="text" icon={<SortAscendingOutlined />}
                    onClick={() => setReorderOpen(true)}
                    style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, width: 30, height: 36 }}
                    title={t('sidebar.reorderMenu', '調整選單順序')} />
                  {/* Collapse sidebar */}
                  <Button type="text" icon={<MenuFoldOutlined />}
                    onClick={() => setCollapsed(true)}
                    style={{ color: 'rgba(255,255,255,0.75)', fontSize: 16, width: 34, height: 36 }}
                    title={t('sidebar.collapseMenu', '收起選單')} />
                </div>
              )}

              {/* When collapsed: only expand button */}
              {collapsed && (
                <Button
                  type="text"
                  icon={<MenuUnfoldOutlined />}
                  onClick={() => setCollapsed(false)}
                  style={{ color: 'rgba(255,255,255,0.75)', fontSize: 16, width: 36, height: 36, marginTop: 4 }}
                  title={t('sidebar.expandMenu', '展開選單')}
                />
              )}
            </div>

            {/* Menu */}
            <div style={{ flex: 1, overflow: 'auto' }}>
              {siderMenu}
            </div>

            {/* Bottom: user + logout */}
            {siderBottom}

          </div>
        </Sider>
      )}

      {/* Mobile: Drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          closable
          onClose={() => setDrawerOpen(false)}
          open={drawerOpen}
          width={240}
          styles={{ body: { padding: 0, background: '#001529' }, header: { background: '#001529', borderBottom: '1px solid rgba(255,255,255,0.1)', padding: '16px 24px' } }}
          title={
            <img
              src="/marcom-ai/marcom-ai-horizontal-onDark.svg"
              alt="marcom AI 行銷平台"
              style={{ height: 64, width: 'auto', display: 'block' }}
            />
          }
        >
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ flex: 1 }}>
              {siderMenu}
            </div>
            {siderBottom}
          </div>
        </Drawer>
      )}

      <Layout style={{ marginLeft: isMobile ? 0 : (collapsed ? 80 : 200), transition: 'margin-left 0.2s' }}>
        {/* Mobile Header with hamburger */}
        {isMobile && (
          <Header style={{
            background: 'linear-gradient(135deg, #001529 0%, #003a8c 100%)',
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'sticky',
            top: 0,
            zIndex: 99,
          }}>
            <Space>
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerOpen(true)}
                style={{ color: '#fff', fontSize: 18 }}
              />
              <img
                src="/marcom-ai/marcom-ai-horizontal-onDark.svg"
                alt="marcom AI 行銷平台"
                style={{ height: 44, width: 'auto', display: 'block' }}
              />
            </Space>
            <Space>
              <LanguageSwitcher ghost size="small" style={{ color: 'rgba(255,255,255,0.85)', borderColor: 'rgba(255,255,255,0.3)' }} />
              <Button
                type="text"
                icon={<LogoutOutlined />}
                onClick={handleLogout}
                style={{ color: 'rgba(255,255,255,0.75)' }}
                size="small"
              />
            </Space>
          </Header>
        )}

        {/* Desktop top-right header bar */}
        {!isMobile && (
          <div style={{
            position: 'fixed', top: 0, right: 0, left: collapsed ? 80 : 200,
            height: 56, zIndex: 99,
            background: 'rgba(255,255,255,0.96)',
            backdropFilter: 'blur(8px)',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
            padding: '0 20px', gap: 12,
            transition: 'left 0.2s',
          }}>
            <LanguageSwitcher size="small" />
            <span style={{ color: '#595959', fontSize: 13 }}>
              {currentUser?.display_name || currentUser?.username}
            </span>
          </div>
        )}

        <Content style={{ padding: isMobile ? '16px' : '96px 40px 24px', background: '#f0f2f5' }}>
          <Routes>
            <Route path="/" element={currentUser?.role === 'customer' ? <CustomerHomePage currentUser={currentUser} /> : <HomePage />} />
            <Route path="/loi" element={<LOIDashboardPage />} />
            <Route path="/loi/manage" element={<LOIManagePage />} />
            <Route path="/scenarios" element={<ScenarioListPage />} />
            <Route path="/scenarios/:id" element={<ScenarioBuilderPage />} />
            <Route path="/scenarios/:id/site" element={<ScenarioSiteAdminPage />} />
            <Route path="/customers" element={<CustomerListPage />} />
            <Route path="/customers/:userId" element={<CustomerBackendPage />} />
            <Route path="/marketing-sites" element={<MarketingSiteListPage />} />
            <Route path="/marketing-sites/:id" element={<MarketingSiteDashboardPage />} />
            <Route path="/products" element={<ProductListPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/email-campaigns" element={currentUser?.role === 'customer' ? <CustomerEmailPage currentUser={currentUser} /> : <EmailCampaignPage />} />
            <Route path="/landing-pages" element={<LandingPageAdminPage />} />
            <Route path="/chatbot" element={<ChatbotAdminPage />} />
            <Route path="/funnel" element={<FunnelDashboardPage />} />
            <Route path="/mira" element={<MiraChatPage />} />
            <Route path="/line" element={<LineSettingsPage />} />
            <Route path="/email-marketing" element={<EmailMarketingPage />} />
            <Route path="/marketing-scheduler" element={<MarketingSchedulerPage />} />
            <Route path="/ai-sales" element={<AISalesCompetitionPage />} />
            <Route path="/ai-sales/bots/:id" element={<BotDetailPage />} />
            <Route path="/ai-sales/bots/:id/chat" element={<BotChatPage />} />
            <Route path="/ai-sales/proposals" element={<BotProposalsPage />} />
            <Route path="/research/trends" element={<TrendsSearchPage />} />
            <Route path="/research/reports" element={<TrendsReportsPage />} />
            <Route path="/research/settings" element={<TrendsSettingsPage />} />
            <Route path="/alayaess-bindings" element={<AlayaessBindingsPage />} />
            <Route path="/alayaess-bots" element={<AlayaessBotsPage />} />
            <Route path="/wav2lip" element={<Wav2LipPage />} />
            <Route path="/video-transcribe" element={<VideoTranscribePage />} />
            <Route path="/aeo" element={<AeoLandingPage />} />
            <Route path="/aeo-scanner" element={<AeoScannerPage />} />
            <Route path="/aeo-fix" element={<AeoFixPage />} />
            <Route path="/citation-monitor" element={<CitationMonitorPage />} />
            <Route path="/module-map" element={<BusinessModuleMapPage />} />
            <Route path="/facebook" element={<FacebookHubPage />} />
            <Route path="/fb-ad-creator" element={<FbAdCreatorPage />} />
            <Route path="/api-keys" element={<ApiKeyPage />} />
            <Route path="/google-ads" element={<GoogleAdsHubPage />} />
            <Route path="/marketing-tools" element={<MarketingToolsPage />} />
            <Route path="/tender" element={<TenderDashboardPage />} />
            <Route path="/email-compose" element={currentUser?.role === 'customer' ? <CustomerEmailPage currentUser={currentUser} /> : <EmailComposePage />} />
            <Route path="/seminar" element={<SeminarAdminPage />} />
            <Route path="/events" element={<EventManagePage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/ai-config" element={<AIModelConfigPage />} />
            <Route path="/coupon-request" element={<CouponRequestPage />} />
            <Route path="/admin-coupon" element={<AdminCouponPage />} />
            <Route path="/billing" element={<BillingPage currentUser={currentUser} />} />
            <Route path="/quotation" element={<QuotationPage currentUser={currentUser} />} />
            <Route path="/presentation" element={<PresentationPage />} />
            <Route path="/partner-manage" element={<PartnerManagePage />} />
            <Route path="/partnership-manage" element={<PartnershipManagePage />} />
            <Route path="/house-ai" element={<HouseDashboardPage />} />
            <Route path="/users" element={<UserManagementPage />} />
            <Route path="/login-analytics" element={<LoginAnalyticsPage />} />
            <Route path="/monitoring" element={<MonitoringPage />} />
            <Route path="/dev-requests" element={<DevRequestsPage currentUser={currentUser} />} />
            <Route path="/terminal" element={<TerminalPage currentUser={currentUser} />} />
            <Route path="/backups" element={<BackupManagementPage />} />
            <Route path="/house-ai-rental" element={<HouseAIRentalPage />} />
            <Route path="/office-search" element={<OfficeSearchPage />} />
            <Route path="/home-search" element={<HomeSearchPage />} />
            <Route path="/jj-hotels" element={<HotelSearchPage />} />
            <Route path="/jj-dashboard" element={<JJDashboardPage />} />
            <Route path="/jj-inbox" element={<JJInboxPage />} />
            <Route path="/jj-crm" element={<JJCRMPage />} />
            <Route path="/jj-properties" element={<JJPropertyManagementPage />} />
            <Route path="/jj-keywords" element={<JJKeywordsPage />} />
            <Route path="/jj-renewals" element={<JJRenewalsPage />} />
            <Route path="/dev-spec" element={<DevSpecPage />} />
            <Route path="/dev-spec/:specId" element={<DevSpecPage />} />
            <Route path="/dev-survey" element={<DevSurveyPage />} />
            <Route path="/ulink-sales" element={<UlinkSalesPage />} />
            <Route path="/ulink-line-inbox" element={<UlinkLineInboxPage />} />
            <Route path="/cdp" element={<CDPPage />} />
            <Route path="/sales-flow" element={<SalesFlowPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Content>

        <Footer style={{
          textAlign: 'center',
          background: '#001529',
          color: 'rgba(255,255,255,0.65)',
          padding: '16px 50px',
          fontSize: isMobile ? 11 : 14,
        }}>
          宇聯科技 Comboware &copy; 2026 — marcom AI 行銷平台
        </Footer>
      </Layout>
    </Layout>
    <MenuReorderModal
      open={reorderOpen}
      onClose={() => setReorderOpen(false)}
      menuItems={rawMenuItems}
      onReorder={(newOrder) => {
        saveMenuOrder(newOrder);
        window.location.reload();
      }}
    />
    <Modal
      title="需要有效訂閱"
      open={subscriptionModal.visible}
      onCancel={() => setSubscriptionModal({ visible: false, message: '' })}
      footer={[
        <Button key="close" onClick={() => setSubscriptionModal({ visible: false, message: '' })}>
          關閉
        </Button>,
        <Button key="billing" type="primary" onClick={() => {
          setSubscriptionModal({ visible: false, message: '' });
          navigate('/billing');
        }}>
          前往訂閱
        </Button>,
      ]}
    >
      <div style={{ padding: '8px 0' }}>
        <p>{subscriptionModal.message}</p>
        <p>請前往「帳務中心」選擇方案並完成訂閱，即可繼續使用 AI SEO 功能。</p>
      </div>
    </Modal>
    </>
  );
}

function SortableMenuItem({ id, label, icon }) {
  const {
    attributes, listeners, setNodeRef,
    transform, transition, isDragging,
  } = window.__dndSortable?.useSortable({ id }) || {};

  const style = {
    transform: window.__dndSortable?.CSS?.Transform?.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 14px',
    background: isDragging ? '#e6f4ff' : '#fafafa',
    border: `1px solid ${isDragging ? '#1890ff' : '#f0f0f0'}`,
    borderRadius: 8, marginBottom: 6, cursor: 'grab',
    userSelect: 'none', boxShadow: isDragging ? '0 4px 12px rgba(0,0,0,0.15)' : 'none',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <span style={{ color: '#bbb', fontSize: 16 }}>⠿</span>
      {icon && <span>{icon}</span>}
      <Typography.Text style={{ fontSize: 13, flex: 1 }}>{label}</Typography.Text>
    </div>
  );
}

function MenuReorderModal({ open, onClose, menuItems, onReorder }) {
  const { t } = useTranslation();
  const [DndContext, setDndContext] = React.useState(null);
  const [sortableLib, setSortableLib] = React.useState(null);
  const groups = menuItems.filter(i => i.children);
  const [order, setOrder] = React.useState(() => groups.map(g => g.key));

  // Lazy load dnd-kit to avoid bundle issues
  React.useEffect(() => {
    if (!open) return;
    setOrder(groups.map(g => g.key));
    Promise.all([
      import('@dnd-kit/core'),
      import('@dnd-kit/sortable'),
      import('@dnd-kit/utilities'),
    ]).then(([core, sortable, utils]) => {
      window.__dndSortable = { useSortable: sortable.useSortable, CSS: utils.CSS };
      setDndContext({ core, sortable });
      setSortableLib(sortable);
    }).catch(() => {});
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    setOrder(prev => {
      const oldIdx = prev.indexOf(active.id);
      const newIdx = prev.indexOf(over.id);
      const next = [...prev];
      next.splice(oldIdx, 1);
      next.splice(newIdx, 0, active.id);
      return next;
    });
  };

  const getGroup = (key) => groups.find(g => g.key === key);
  const getLabel = (key) => {
    const g = getGroup(key);
    if (!g) return key;
    const lbl = g.label;
    if (typeof lbl === 'string') return lbl;
    if (lbl?.props?.children) {
      const c = lbl.props.children;
      return Array.isArray(c) ? c.filter(Boolean).join('') : String(c);
    }
    return key;
  };

  return (
    <Modal
      title={<span><SortAscendingOutlined style={{ marginRight: 8 }} />{t('sidebar.dragReorder', '拖拉調整選單順序')}</span>}
      open={open}
      onCancel={onClose}
      onOk={() => { onReorder(order); onClose(); }}
      okText={t('sidebar.saveAndApply', '儲存並套用')}
      cancelText={t('sidebar.cancel', '取消')}
      width={360}
    >
      <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 12 }}>
        {t('sidebar.dragHint', '拖拉')} <span style={{ background: '#f0f0f0', padding: '0 4px', borderRadius: 3 }}>⠿</span> {t('sidebar.dragHint2', '調整 group 順序，儲存後套用。')}
      </Typography.Text>

      {DndContext ? (
        <DndContext.core.DndContext
          collisionDetection={DndContext.core.closestCenter}
          onDragEnd={handleDragEnd}
        >
          <DndContext.sortable.SortableContext
            items={order}
            strategy={DndContext.sortable.verticalListSortingStrategy}
          >
            {order.map(key => (
              <SortableMenuItem key={key} id={key} label={getLabel(key)}
                icon={getGroup(key)?.icon} />
            ))}
          </DndContext.sortable.SortableContext>
        </DndContext.core.DndContext>
      ) : (
        // Fallback while loading
        <div>
          {order.map((key, idx) => (
            <div key={key} style={{ padding: '10px 14px', background: '#fafafa',
              border: '1px solid #f0f0f0', borderRadius: 8, marginBottom: 6,
              display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ color: '#bbb' }}>{idx + 1}.</span>
              <Typography.Text style={{ fontSize: 13 }}>{getLabel(key)}</Typography.Text>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}

function MarComLandingWrapper({ setAuthMode }) {
  const navigate = useNavigate();
  return <MarComLandingPage onGoLogin={() => { setAuthMode('login'); navigate('/login'); }} />;
}

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'register'

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('spo_auth_token');
    if (!token) {
      setCurrentUser(null);
      setAuthChecked(true);
      return;
    }
    try {
      const res = await authAPI.me();
      setCurrentUser(res.data);
    } catch (error) {
      console.log('Auth check failed, clearing token');
      localStorage.removeItem('spo_auth_token');
      setCurrentUser(null);
    } finally {
      setAuthChecked(true);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const handleLoginSuccess = () => {
    checkAuth();
  };

  const handleRegisterSuccess = () => {
    checkAuth();
  };

  const handleLogout = () => {
    setCurrentUser(null);
    setAuthMode('login');
  };

  if (!authChecked) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #001529 0%, #003a8c 100%)',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  const renderAuthPage = () => {
    if (authMode === 'register') {
      return (
        <RegisterPage
          onRegisterSuccess={handleRegisterSuccess}
          onSwitchToLogin={() => setAuthMode('login')}
        />
      );
    }
    return (
      <LoginPage
        onLoginSuccess={handleLoginSuccess}
        onSwitchToRegister={() => setAuthMode('register')}
      />
    );
  };

  return (
    <Router>
      <Routes>
        {/* Public pages - standalone, no navigation, no auth required */}
        <Route path="/survey/:token" element={<FullSurveyPage />} />
        <Route path="/survey-old/:token" element={<LOISurveyPage />} />
        <Route path="/tender/:token" element={<TenderConfirmPage />} />
        <Route path="/prices/:token" element={<PriceCatalogPage />} />
        <Route path="/s/:slug/*" element={<ScenarioSiteLayout />} />
        <Route path="/h/:slug/*" element={<HousePortalLayout />} />
        <Route path="/partner/:token" element={<PartnerPortalPage />} />
        <Route path="/partnership" element={<PartnershipPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/spec/:token" element={<DevSpecViewPage />} />

        {/* Public landing page */}
        {!currentUser && (
          <Route path="/" element={
            <MarComLandingWrapper setAuthMode={setAuthMode} />
          } />
        )}

        {/* Open House kiosk（公開，免登入） */}
        <Route path="/oh/:slug" element={<OpenHouseKioskPage />} />
        <Route path="/oh/:slug/admin" element={<OpenHouseAdminPage />} />

        {/* Login / Register */}
        {!currentUser && (
          <Route path="/login" element={renderAuthPage()} />
        )}

        {/* Main app with navigation layout */}
        <Route path="*" element={
          !currentUser ? (
            renderAuthPage()
          ) : (
            <AppLayout currentUser={currentUser} onLogout={handleLogout} />
          )
        } />
      </Routes>
    </Router>
  );
}

export default App;
